import { Section } from './Section';
import { wishCookieIcon } from '@app/assets';

export function LevelUpSection() {
  return (
    <Section
      img={
        <img
          src={wishCookieIcon}
          alt="wish cookie"
          className="w-full max-w-[225px] -rotate-[9.5deg]"
        />
      }
      titleTranslationKey="level_up_title"
      descriptionTranslationKey="level_up_text"
    />
  );
}
